import { Component } from "react";
import Progress from "./CustomTool/Progress";
import { Box, CardContent, CardMedia, Grid } from "@mui/material";
import CtDtp from "./CustomTool/CtDtp";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import {
  get_YMD_from_SYS,
  validatedate_min_max,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import ResetDate from "../images/resetdate.png";

class ProductionList extends Component {
  state = {
    columns: [
      { id: "dtpDtate", label: "Date" },
      { id: "cmbRMStockid", label: "RM Stock Id" },
      { id: "cmbRMItemName", label: "RM Item Name" },
      { id: "cmbRMPacking", label: "RM Packing" },
      { id: "txtRMQty", label: "Consumed Qty." },
      { id: "cmbFGStockid", label: "FG Stock Id" },
      { id: "cmbFGItemName", label: "FG Item Name" },
      { id: "cmbFGPacking", label: "FG Packing" },
      { id: "txtFGQty", label: "Production Qty." },
    ],
    rows: [],
    formData: {
      dtpFromDate: "",
      dtpDate: "",
    },
  };
  handleOnChange(e) {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      }
      //   () => {
      //     if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
      //       this.setfrom_todate();
      //     }
      //   }
    );
  }

  //   setfrom_todate = (reset = false) => {
  //     setlocalstoragedate(
  //       "Production",
  //       this.state.formData.dtpFromDate,
  //       this.state.formData.dtpToDate,
  //       reset
  //     );
  //     if (reset) {
  //       window.location.reload();
  //       this.onFormLoad();
  //     }
  //   };

  //   validateDate = () => {
  //     let result = false;
  //     if (this.state.formData.dtpFromDate.length <= 0) {
  //       this.props.toastErrorMsg("Enter Date", "dtpFromDate");
  //     } else if (
  //       validatedate_min_max(
  //         this.state.formData.dtpFromDate,
  //         "dtpFromDate",
  //         this.props.toastErrorMsg
  //       ) == false
  //     ) {
  //       return result;
  //     } else if (this.state.formData.dtpToDate.length <= 0) {
  //       this.props.toastErrorMsg("Enter Date", "dtpToDate");
  //     } else if (
  //       validatedate_min_max(
  //         this.state.formData.dtpToDate,
  //         "dtpToDate",
  //         this.props.toastErrorMsg
  //       ) == false
  //     ) {
  //       return result;
  //     } else {
  //       result = true;
  //     }
  //     return result;
  //   };
  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Production List</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: "inline-flex" }}>
                <CardContent style={{ paddingBottom: "0px" }}>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  //   onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"dtpToDate"}
                  accountYear={localStorage.getItem("ACY")}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  //   onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.getInfo}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtBtn label="Load" onClick={this.getInfo} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          // rows={rows}
          // rowsCount={rowsCount}
          // rowsPerPage={this.state.rowsPerPage}
          // handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          // handleOnActionClick={this.handleARDonActionClick}
          // actionList={this.state.actionList}
          // keyColumn={this.state.keyColumn}
          // handleOnSearchChange={this.handleOnSearchChange}
          // searchColumns={this.state.searchColumns}
          // searchData={this.state.searchData}
          // provideSearch={true}
          // // provideSearch={true}
          // handleOnNewEntryClick={this.handleOnNewEntryClick}
          // toolTipNewEntry="Purchase Entry"
        />
        {/* <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid> */}
      </form>
    );
  }
}
export default ProductionList;
